import React from 'react';
import PropTypes from 'prop-types';
import Isvg from 'react-inlinesvg';
import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import { bem } from 'helpers/class-name';
import { makePath } from 'helpers/link-generation';
import { Card } from 'components/Card';
import Message from 'components/Message';
import { ICONS } from 'constants/icons';
import { intlMessage } from 'constants/propTypes';
import messages from '../ManageServices.messages';

import './EmptyState.scss';

const { block, element } = bem('empty-state');

const EmptyState = ({ venueId, headerMessage, subheaderMessage, buttonMessage, tab, iconSource, iconTitleMessage }) => {
  const intl = useIntl();

  return (
    <Card centered className={block()}>
      <Isvg src={iconSource} title={intl.formatMessage(iconTitleMessage)} />
      <Message className={element('header')} message={headerMessage} />
      <Message className="text--regular" message={subheaderMessage} />
      <Link
        to={makePath.manageServicesAdd({ venueId, tab })}
        className={element('link')}
        data-cypress="manage-services-empty-state-button">
        <Isvg src={ICONS.addBlue} title={intl.formatMessage(messages.emptyState.plusIcon)} />
        <Message className="ml--" message={buttonMessage} />
      </Link>
    </Card>
  );
};

EmptyState.propTypes = {
  venueId: PropTypes.number,
  headerMessage: intlMessage,
  subheaderMessage: intlMessage,
  buttonMessage: intlMessage,
  tab: PropTypes.string,
  iconSource: PropTypes.node,
  iconTitleMessage: intlMessage,
};

export default EmptyState;
